import { ISubscriptionsState } from '../state';

export const show_pro_feature_modal_factory = (state: ISubscriptionsState) => () => {
    state.showing_pro_feature_modal.value = true;
};
